import React, { Component } from 'react';
import {
	Button,
	Col,
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
	Form,
	FormGroup,
	FormText,
	Input,
	Label,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	Row,
	UncontrolledDropdown
} from 'reactstrap';
import PropTypes from 'prop-types';
import axios from 'axios';
import ReCAPTCHA from 'react-google-recaptcha';

const MAX_MSG_LENGTH = 500;

class NewCustomerForm extends Component {
	constructor(props) {
		super(props);

		this.state = {
			firstName: '',
			lastName: '',
			email: '',
			phone: '',
			address: '',
			city: '',
			state: 'N/A',
			zip: '',
			message: '',
			msgCharsLeft: MAX_MSG_LENGTH,
			modalPostForm: false,
			modalSuccess: false,
			modalClearForm: false,
			recaptchaResponse: null,
			modalErrorMessage: 'Something went wrong. Please try again later.'
		};
	}

	clearForm = () => {
		this.setState({
			firstName: '',
			lastName: '',
			email: '',
			phone: '',
			address: '',
			city: '',
			state: 'N/A',
			zip: '',
			message: '',
			msgCharsLeft: MAX_MSG_LENGTH,
			modalClearForm: false
		});
	};

	postForm = () => {
		axios.post('/api/customer-forms/add', {
			recaptchaResponse: this.state.recaptchaResponse,
			firstName: this.state.firstName,
			lastName: this.state.lastName,
			email: this.state.email,
			phone: this.state.phone,
			address: this.state.address,
			city: this.state.city,
			state: this.state.state,
			zip: this.state.zip,
			message: this.state.message
		})
		.then((res) => {
			this.setState({
				modalPostForm: true,
				modalSuccess: true
			});
		})
		.catch((err) => {
			this.setState({
				modalPostForm: true,
				modalSuccess: false,
				modalErrorMessage: err.response.data.error
			}, this.refs.recaptcha.reset());
		});
	};

	printForm = () => {

	};

	handleFirstNameChange = (e) => {
		this.setState({firstName: e.target.value});
	};

	handleLastNameChange = (e) => {
		this.setState({lastName: e.target.value});
	};

	handleEmailChange = (e) => {
		this.setState({email: e.target.value});
	};

	handlePhoneChange = (e) => {
		this.setState({phone: e.target.value});
	};

	handleAddressChange = (e) => {
		this.setState({address: e.target.value});
	};

	handleCityChange = (e) => {
		this.setState({city: e.target.value});
	};

	handleStateChange = (e) => {
		this.setState({state: e.target.value});
	};

	handleZipChange = (e) => {
		this.setState({zip: e.target.value});
	};

	handleMessageChange = (e) => {
		this.setState({
			message: e.target.value,
			msgCharsLeft: MAX_MSG_LENGTH - e.target.value.length
		}, () => {
			if (this.state.msgCharsLeft < 0) {
				this.setState({
					message: this.state.message.slice(0, MAX_MSG_LENGTH),
					msgCharsLeft: 0
				})
			}
		});
	};

	onDropdownStateClick = (st) => {
		this.setState({ state: st});
	};

	onVerifyRecaptcha = (res) => {
		this.setState({ recaptchaResponse: res });
	};

	toggleModalPostForm = () => {
		this.setState({
			modalPostForm: !this.state.modalPostForm,
		}, () => {
			if (this.state.modalSuccess) {
				this.props.onSuccess();
			}
		});
	};

	toggleModalClearForm = () => {
		this.setState({
			modalClearForm: !this.state.modalClearForm,
		});
	};

	render() {
		return (
			<div>
				<Form>
					<FormGroup>
						<Label for="firstName">First Name</Label>
						<Input type="text" name="firstName" id="firstName" size="lg" value={this.state.firstName} onChange={(e) => this.handleFirstNameChange(e)}  />
					</FormGroup>
					<FormGroup>
						<Label for="lastName">Last Name</Label>
						<Input type="text" name="lastName" id="lastName" size="lg" value={this.state.lastName} onChange={(e) => this.handleLastNameChange(e)}  />
					</FormGroup>
					<FormGroup>
						<Label for="email">Email</Label>
						<Input type="text" name="email" id="email" size="lg" value={this.state.email} onChange={(e) => this.handleEmailChange(e)}  />
					</FormGroup>
					<FormGroup>
						<Label for="phone">Phone</Label>
						<Input type="text" name="phone" id="phone" size="lg" value={this.state.phone} onChange={(e) => this.handlePhoneChange(e)}  />
					</FormGroup>
					<FormGroup>
						<Label for="address">Address</Label>
						<Input type="text" name="address" id="address" size="lg" value={this.state.address} onChange={(e) => this.handleAddressChange(e)}  />
					</FormGroup>
					<Row>
						<Col xs="12" sm="6">
							<FormGroup>
								<Label for="city">City</Label>
								<Input type="text" name="city" id="city" size="lg" value={this.state.city} onChange={(e) => this.handleCityChange(e)}  />
							</FormGroup>
						</Col>
						<Col xs="6" sm="3">
							<FormGroup>
								<Label for="state">State</Label>
								<UncontrolledDropdown name="state" id="state">
									<DropdownToggle caret>
										{this.state.state}
									</DropdownToggle>
									<DropdownMenu style={{height: "auto", maxHeight: "206px", overflowX: "hidden"}}>
										<DropdownItem onClick={() => this.onDropdownStateClick("N/A")}>N/A</DropdownItem>
										<DropdownItem divider />
										<DropdownItem onClick={() => this.onDropdownStateClick("AK")}>Alaska</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("AL")}>Alabama</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("AR")}>Arkansas</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("AZ")}>Arizona</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("CA")}>California</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("CO")}>Colorado</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("CT")}>Connecticut</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("DC")}>District of Columbia</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("DE")}>Delaware</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("FL")}>Florida</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("GA")}>Georgia</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("HI")}>Hawaii</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("IA")}>Iowa</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("ID")}>Idaho</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("IL")}>Illinois</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("IN")}>Indiana</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("KS")}>Kansas</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("KY")}>Kentucky</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("LA")}>Louisiana</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("MA")}>Massachusetts</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("MD")}>Maryland</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("ME")}>Maine</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("MI")}>Michigan</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("MN")}>Minnesota</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("MO")}>Missouri</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("MS")}>Mississippi</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("MT")}>Montana</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("NC")}>North Carolina</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("ND")}>North Dakota</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("NE")}>Nebraska</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("NH")}>New Hampshire</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("NJ")}>New Jersey</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("NM")}>New Mexico</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("NV")}>Nevada</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("NY")}>New York</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("OH")}>Ohio</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("OK")}>Oklahoma</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("OR")}>Oregon</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("PA")}>Pennsylvania</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("PR")}>Puerto Rico</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("RI")}>Rhode Island</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("SC")}>South Carolina</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("SD")}>South Dakota</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("TN")}>Tennessee</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("TX")}>Texas</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("UT")}>Utah</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("VA")}>Virginia</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("VT")}>Vermont</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("WA")}>Washington</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("WI")}>Wisconsin</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("WV")}>West Virginia</DropdownItem>
										<DropdownItem onClick={() => this.onDropdownStateClick("WY")}>Wyoming</DropdownItem>
									</DropdownMenu>
								</UncontrolledDropdown>
							</FormGroup>
						</Col>
						<Col xs="6" sm="3">
							<FormGroup>
								<Label for="zip">Zip Code</Label>
								<Input type="text" name="zip" id="zip" size="lg" value={this.state.zip} onChange={(e) => this.handleZipChange(e)}  />
							</FormGroup>
						</Col>
					</Row>
					<FormGroup>
						<Label for="message">Message</Label>
						<Input type="textarea" name="message" id="message" value={this.state.message} style={{"height": "150px"}} onChange={(e) => this.handleMessageChange(e)} />
						<FormText color="muted">
							Characters remaining: {this.state.msgCharsLeft}
						</FormText>
					</FormGroup>

					{process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY && (
						<div className="mt-5 mb-5">
							<ReCAPTCHA
								ref="recaptcha"
								sitekey={process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY}
								onChange={this.onVerifyRecaptcha}
							/>
						</div>
					)}

					<Row>
						<Col xs={12} lg={4} className="mb-3">
							<Button color="primary" onClick={this.postForm}>Submit</Button>{' '}
						</Col>
						<Col xs={12} lg={4} className="mb-3">
							<Button color="info" onClick={this.printForm}>Print Form</Button>{' '}
						</Col>
						<Col xs={12} lg={4} className="mb-3">
							<Button color="danger" onClick={this.toggleModalClearForm}>Clear Form</Button>
						</Col>
					</Row>
				</Form>

				<Modal isOpen={this.state.modalClearForm} toggle={this.toggleModalClearForm}>
					<ModalHeader toggle={this.toggleModalClearForm}>Clear Form</ModalHeader>
					<ModalBody>
						<div>Are you sure you want to start over?</div>
					</ModalBody>
					<ModalFooter>
						<Button color="danger" onClick={this.clearForm}>Yes</Button>
						<Button color="primary" onClick={this.toggleModalClearForm}>No</Button>
					</ModalFooter>
				</Modal>

				<Modal isOpen={this.state.modalPostForm} toggle={this.toggleModalPostForm}>
					<ModalHeader toggle={this.toggleModalPostForm}>Form Submission</ModalHeader>
					<ModalBody>
						{this.state.modalSuccess ? (
							<div>Success! Your form has been received.</div>
						) : (
							<div>ERROR: {this.state.modalErrorMessage}</div>
						)}
					</ModalBody>
					<ModalFooter>
						<Button color="primary" onClick={this.toggleModalPostForm}>OK</Button>
					</ModalFooter>
				</Modal>

			</div>
		);
	}
}

NewCustomerForm.propTypes = {
  onSuccess: PropTypes.func,
};

export default NewCustomerForm;


// WEBPACK FOOTER //
// ./src/components/NewCustomerForm.js